import React, { useContext, useState, Component } from "react";
import { Redirect } from "react-router";
import styled from "styled-components";

import RoomService from "../../service/rooms-service";
import PlaylistService from "../../service/playlist-service";
import ToastService from "../../service/toast-service";
import Button from "@material-ui/core/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Theme } from "../../theme/theme-provider";
import { Box, Text, Col, Row, SearchBox, VGap, ButtonGroup } from "../../comps";

const Wrapper = styled(Col)`
  width: 100%;
  margin-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
  @media ${({ theme }) => theme.screenSize.portrait} {
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Line = styled(Box)`
  width: 100%;
  height: 1px;
  background: #d7e0da;
`;

const StyledText = styled(Text)`
  font-family: "Lucida Console", Courier, monospace;
  -moz-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  -webkit-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  -o-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  -ms-transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
  transform: scale(1) rotate(0deg) translate(0px, 0px) skew(-4deg, 0deg);
`;

const ButtonsWrapper = styled(Box)`
  width: 100%;
  height: 50px;
`;

const TextContainer = styled(Row)`
  margin-top: 15px;
  margin-bottom: 25px;
  padding: 10px;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
  background: ${({ theme }) => theme.color.BLACK_1};
  border-radius: 3px;
`;

const Actions = ({ items, isModalView, to, handleAddSongs, actions }) => {
  const convertAll = (
    <Button style={{ flex: 1, color: "#d7e0da" }} onClick={actions.convert}>
      Convert all to videos
    </Button>
  );
  if (isModalView) {
    const addAll = (
      <Button
        style={{ flex: 1, color: "#d7e0da" }}
        onClick={() => {
          ToastService.infoToast(
            `adding all to ${to === "room" ? `room's Queue` : `playlist`}`
          );
          handleAddSongs(actions.getYoutubeVideos(items));
        }}
      >
        {`Add all songs to ${to === "room" ? `room's Queue` : `playlist`}`}
      </Button>
    );
    return (
      <ButtonGroup
        buttons={[addAll]} // removing convert all
        color="#d7e0da"
        outline={true}
      />
    );
  } else {
    const createNew = (
      <Button style={{ flex: 1, color: "#d7e0da" }} onClick={actions.saveAsNew}>
        save as a new playlist
      </Button>
    );
    const saveToExisting = (
      <Button
        style={{ flex: 1, color: "#d7e0da" }}
        onClick={actions.addToPlaylist}
      >
        add all to existing playlist
      </Button>
    );

    return (
      <ButtonGroup
        buttons={[createNew, saveToExisting]} // removing convert all
        color="#d7e0da"
        outline={true}
      />
    );
  }
};

const STATUS = { IDLE: 0, LOADING: 1, SUCCESS: 2, ERROR: 3, CONVERT: 4 };

export default ({ items, modalData, actions }) => {
  const createNewPlaylist = () => {};
  // create new playlist
  const isModalView = modalData && true;
  const to = modalData && modalData.to;
  const handleAddSongs = modalData && modalData.handleAddSongs;

  const status = actions.getStatus();

  const info = actions.getInfo();
  const text = `Imported ${info.total || "x"} items. Found ${
    info.youtube || "0"
  } youtube videos and ${
    info.spotify || "0"
  } sotify tracks. For adding spotify track to playlist or rooms, you need to convert them to youtube videos. you can either convert them one by one or convert all at once. Since, you are logged in as Guest account, you can convert upto 50 spotify songs daily!`;

  return (
    <Wrapper>
      {(info.spotify || 0) > 0 && (
        <TextContainer>
          <FontAwesomeIcon
            style={{
              fontSize: "20px",
              color: Theme.color.GRAY_1,
              margin: "5px",
            }}
            icon={faInfoCircle}
          />
          <Text
            color={Theme.color.GRAY_0}
            fontSize="16px"
            textAlign="left"
            marginLeft="8px"
          >
            {text}
          </Text>
        </TextContainer>
      )}
      {status === STATUS.CONVERT && (
        <Text
          color={Theme.color.RED_6}
          fontSize="16px"
          textAlign="left"
          marginBottom="20px"
        >{`converting ${info.youtube}/${info.total}...`}</Text>
      )}
      <ButtonsWrapper>
        <Actions
          isModalView={isModalView}
          to={to}
          handleAddSongs={handleAddSongs}
          actions={actions}
          items={items}
        />
      </ButtonsWrapper>
    </Wrapper>
  );
};
